import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { computed, defineComponent, onMounted, ref, toRefs } from "@vue/composition-api";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import { parseSyncStatus } from "@Broker/js/custom/utils";
import Badge from "@Shared/components/general/badge.vue";
import SyncRefresh from "./sync-refresh.vue";
import { getApplicationSyncEventTypeText, getApplicationSyncErrorMessage } from "@Broker/js/custom/utils";
import * as ApplicationActions from "@Broker/@Modules/clients/applications/application/store/application-actions";
import * as AccountActions from "@Broker/@Modules/main/store/account/account-actions";
import { useAccountStoreActions } from "@Broker/@Modules/main/store/account/account-helpers";
const {
  useGetters: useApplicationStoreGetters,
  useActions: useApplicationStoreActions
} = createNamespacedHelpers("ApplicationStore");
export default defineComponent({
  name: "ApplicationSyncStatus",
  components: {
    Badge,
    SyncRefresh
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    updatingSyncStatus: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      applicationId,
      clientUsername
    } = toRefs(props);
    const retrying = ref(false);
    const {
      APPLICATION_SYNC_STATUS,
      ARE_FILOGIX_DETAILS_VERIFIED,
      IS_CURRENT_USER_APPLICATION_OWNER
    } = useApplicationStoreGetters([ApplicationGetters.APPLICATION_SYNC_STATUS, ApplicationGetters.ARE_FILOGIX_DETAILS_VERIFIED, ApplicationGetters.IS_CURRENT_USER_APPLICATION_OWNER]);
    const {
      TOGGLE_APPLICATION_FEATURE_DISCOVERY
    } = useAccountStoreActions([AccountActions.TOGGLE_APPLICATION_FEATURE_DISCOVERY]);
    const {
      LOAD_APPLICATION_SYNC_STATUS,
      RETRY_APPLICATION_SYNC
    } = useApplicationStoreActions([ApplicationActions.LOAD_APPLICATION_SYNC_STATUS, ApplicationActions.RETRY_APPLICATION_SYNC]);
    const status = computed(() => {
      const status = APPLICATION_SYNC_STATUS.value(applicationId.value);
      return _objectSpread(_objectSpread(_objectSpread({}, parseSyncStatus(status)), status.details), {}, {
        syncing: status.syncing,
        expertApplicationId: status.expertApplicationId
      });
    });
    const isUnableToSync = computed(() => {
      return status.value.isError;
    });
    const syncTextVariant = computed(() => {
      if (status.value.type === "info") return "text-info";
      if (isUnableToSync.value && !status.value.syncing) return "text-danger";
      return "text-primary";
    });
    const syncTextIcon = computed(() => {
      if (isUnableToSync.value) return "times-circle";
      if (status.value.type === "info") return "info-circle";
      return "check-circle";
    });
    const showRetryButton = computed(() => !status.value.expertApplicationId && !status.value.syncing && areFilogixDetailsVerified.value);
    const showDetailsText = computed(() => status.value.code !== "success");
    const errorMessagePath = computed(() => {
      const basePath = getApplicationSyncErrorMessage(status.value, true);
      return IS_CURRENT_USER_APPLICATION_OWNER.value({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value
      }) && status.value.isErrorWithFilogixDetails && basePath ? `${basePath}_LINK` : basePath;
    });
    const areFilogixDetailsVerified = computed(() => {
      return ARE_FILOGIX_DETAILS_VERIFIED.value({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value
      });
    });
    onMounted(async () => {
      if (areFilogixDetailsVerified.value) await LOAD_APPLICATION_SYNC_STATUS({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value
      });
    });
    const handleRetry = async () => {
      retrying.value = true;
      emit("update-sync-status", {
        startImmediately: true
      });
      RETRY_APPLICATION_SYNC({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value
      });
      retrying.value = false;
    };
    const handleShowApplicationFeatureDiscovery = () => {
      TOGGLE_APPLICATION_FEATURE_DISCOVERY({
        applicationFeatureDiscovery: true
      });
    };
    return {
      status,
      isUnableToSync,
      syncTextVariant,
      syncTextIcon,
      showRetryButton,
      showDetailsText,
      retrying,
      errorMessagePath,
      getApplicationSyncEventTypeText,
      getApplicationSyncErrorMessage,
      handleRetry,
      handleShowApplicationFeatureDiscovery
    };
  }
});